export default __webpack_public_path__ + "static/media/AvatarKids-04.78ba09bd.png";